export const ServiceCardTypeEnum = Object.freeze({
    ISSUE_HANDLE: 'ISSUE_HANDLE',
    SERVICE: 'SERVICE',
});
